import React, { Component } from 'react'
import { Row, Col, Menu, Rate, Icon, Spin, Tag, Modal, Pagination, Button, Popover, Dropdown } from 'antd'
import QRCode from 'qrcode.react'
import { Link } from 'react-router-dom'
import Slider from "react-slick"
import { app, api, config } from "../../app"
import default_img from "../../assets/head_default_img.png"
import asyncComponent from '../../components/asyncComponent'
import utils from "../../utils"

const BarReact = asyncComponent(() => import('../../components/BarEcharts'))  //柱形图组件

const MenuItem = Menu.Item
const confirm = Modal.confirm;

function loadNode() {
    return (<div className="load-example"><Spin size="large" /></div>)
}

function notNode(text) {
    return (
        <div className="no-data">
            <Icon type="info-circle" />
            <span className="no-data-text">{text}</span>
        </div>
    )
}

function chartOptionSet(dataInfo, indexno) {
    const categories = [], data = []
    for (let i = 0; i < dataInfo.length; i++) {
        categories.push(dataInfo[i].vname)
        data.push(dataInfo[i].duration || 0)
    }
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'none'
            }
        },
        xAxis: {
            axisTick: {
                show: false,
            },
            axisLabel: {
                interval: 0,
                color: (item, index) => {
                    if (index >= dataInfo.length) {
                        return '#AFCCE2'
                    }
                    if (dataInfo[index].indexno === indexno) {
                        return '#1890ff'
                    }
                    return '#AFCCE2'
                },
            },
            splitLine: { show: false },//去除网格线
            data: categories,
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#dddddd'
                }
            },
        },
        yAxis: {
            // name: '救援时长（时）',
            axisTick: {
                show: false,
            },
            splitLine: { show: false },//去除网格线
            minInterval: 1,
            nameTextStyle: {
                color: '#666666',
                padding: [0, 10, 10, 0]
            },
            axisLabel: {
                show: true,
                color: '#666'
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#dddddd'
                }
            },
        },
        series: [{
            name: '救援时长',
            type: 'bar',
            data: data,
            barWidth: 12,
            itemStyle: {
                normal: {
                    color: ({ dataIndex }) => {
                        if (dataInfo[dataIndex].indexno === indexno) {
                            return '#1890ff'
                        }
                        return '#AFCCE2'
                    }
                }
            },
            label: {
                normal: {
                    show: true,
                    position: 'top',
                    fontSize: 12,
                    formatter: '{c} 时'
                }
            }
        }]
    }
}

class PMember extends Component {
    constructor(props) {
        super(props)
        const { indexno, team_id } = props.match.params
        this.state = {
            isTrue: false,
            img: config.imgUrl + "/Uploads/jiaZheng99krltkerkewrewkrewkrewpkrekrpweewfe.jpg",
            indexno,
            team_id,
            menu_key: ['information'],
            menus: [
                { key: 'information', name: '基本信息', content: null },
                { key: 'skill', name: '获得技能', content: null },
                { key: 'equipment', name: '个人装备', content: null },
                { key: 'honorwall', name: '荣誉墙', content: null },
                { key: 'ranking', name: '排行榜', content: null },
                { key: 'train', name: '队务建设及后台经历', content: null },
                { key: 'rescue', name: '救援经历', content: null },
                { key: 'drill', name: '演练及培训经历', content: null },
                { key: 'social', name: '社会服务经历', content: null },
                { key: 'donation', name: '捐赠记录', content: null },
                { key: 'leaveteam', name: '离队/清退', content: null },
            ],
            info: {
                train: {},
                rescue: {},
                drill: {},
                socialService: {},
                donate: {},
                rescueYear: [],
                trainYear: [],
                drillYear: [],
                socialServiceYear: [],
                donateYear: [],
            },
            data_loading: true,
            ppeClass_loading: true,
            ppe_loading: false,
            ppeClassList: [],
            ppeList: [],
            train_menu_key: '',
            rescue_menu_key: '',
            drill_menu_key: '',
            socialService_menu_key: '',
            donate_menu_key: '',
            experience_loading: false,
            experience_visible: false,
            experience_text: '',
            experience_api: '',
            experience_year: '',
            experience_key: '',
            experienceList: [],
            report_modal_loading: false,
            e_page: 1,
            e_total: 0,
            chartOptions: {},
            ranking_loading: true,
            has_ranking: false,
            ranking_key: 0,
            ranking_filters: [],
            ranking_menu: '3',
            ranking: '-',
        }
    }

    async componentDidMount() {
        // 判断token
        // 1. token参数是否存在
        // 2. '?token'必须放在传参的第一位
        // 3. token后面的值是否存在
        // 4. token值是否有效

        // 是否显示搜索结果
        // 存在token且有效则显示搜索结果
        // 存在token且无效则显示假证

        let a = window.location.search;
        let b = a.indexOf('?token');
        // console.log(a);
        // console.log(a.indexOf('?token'));
        // 1. token参数是否存在
        if (b == -1) {
            // console.log("假证：不存在token参数");
            this.setState({
                isTrue: true,
                data_loading: false,
            });
        } else {
            let c = a.substr(0, 7);
            // 2. '?token='必须放在传参的第一位
            if (c == '?token=') {
                // 第2步正确，进行第3步
                // 3. token后面的值是否存在
                let d = a.substr(7);
                // 截取url中传递的token，并返回数据库进行查询
                // 该token存在且有效则加载搜索页面，否者显示假证页面
                if (d.length > 0) {
                    // 第3步正确，进行第4步
                    // 4. token值是否有效
                    // console.log('存在token，返回数据库查询是否有效 ==> '+c);
                    // 有效，显示搜索结果
                    this.getTokeni(d);                    

                } else {
                    // console.log("token参数值为空，假证！");
                    this.setState({
                        isTrue: true,
                        data_loading: false,
                    });
                }

            } else {
                // console.log("传参的第一位没有token，假证！");
                this.setState({
                    isTrue: true,
                    data_loading: false,
                });
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    async componentWillReceiveProps(props) {
        const { indexno } = props.match.params
        if (indexno !== this.state.indexno) {
            await this.setData({
                indexno,
                data_loading: true,
                menu_key: ['information'],
                ppeList: [],
                train_menu_key: '',
                rescue_menu_key: '',
                drill_menu_key: '',
                socialService_menu_key: '',
                donate_menu_key: '',
                chartOptions: {},
                experience_loading: false,
                experience_visible: false,
                experience_text: '',
                experience_api: '',
                experience_year: '',
                experience_key: '',
                experienceList: [],
                report_modal_loading: false,
                e_page: 1,
                e_total: 0,
                has_ranking: false,
                ranking_loading: true,
                ranking_key: 0,
                ranking_filters: [],
                ranking_menu: '3',
                ranking: '-',
            })
            await this.dataSource()
            if (this.state.has_ranking) {
                await this.rankingSource()
            }
        }
    }

    setData = (data) => app.setStateSync(this, data)

    /**
* 获取token
* @returns {Promise<void>}
*/
    getTokeni = async (e) => {

        let that = this;

        let { flag, data, msg } = await app.post(api.getToken);

        if (flag === 1) {

            if (data.token == e) {
                that._isMounted = true
                await that.dataSource()
                await that.ppeClassSource()
                if (that.state.has_ranking) {
                    await that.rankingSource()
                }
            } else {
                // console.log("token无效，假证！");
                that.setState({
                    isTrue: true,
                    data_loading: false,
                });
            }

        } else {
            app.alert(msg, 'warn');
        }
    };

    /**
     * 数据源
     */
    dataSource = async () => {
        const { indexno, team_id } = this.state,
            params = { indexno, team_id }
        if (indexno === app.getData('indexno')) {
            params.account = app.getData('account')
        }
        let { flag, data, msg } = await app.post(api.UserInfo, params)
        let state = { data_loading: false }
        if (flag === 1) {
            data.rescueYear = Object.keys(data.rescue)
            data.trainYear = Object.keys(data.train)
            data.drillYear = Object.keys(data.drill)
            data.socialServiceYear = Object.keys(data.socialService)
            data.donateYear = Object.keys(data.donate)
            data.province = (data.province || []).map(p => ({ teamno: p.val, teamname: p.name }))
            state.info = data
            state.train_menu_key = data.trainYear[data.trainYear.length - 1]
            state.rescue_menu_key = data.rescueYear[data.rescueYear.length - 1]
            state.drill_menu_key = data.drillYear[data.drillYear.length - 1]
            state.socialService_menu_key = data.socialServiceYear[data.socialServiceYear.length - 1]
            state.donate_menu_key = data.donateYear[data.donateYear.length - 1]
            state.ppeList = data.ppe || []
            state.ranking_filters = data.teamname
            if (data.volunteer_state !== '4' && data.volunteer_state !== '5' && data.teamname.length > 0) {
                state.has_ranking = true
            }
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
        return data
    }

    /**
     * 技能分类数据源
     * @returns {Promise<void>}
     */
    ppeClassSource = async () => {
        let { flag, data, msg } = await app.post(api.PpeClass, { parent: 1 })
        let state = { ppeClass_loading: false }
        if (flag === 1) {
            state.ppeClassList = data
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 技能数据源
     * @param id
     * @returns {Promise<void>}
     */
    ppeSource = async (id) => {
        await this.setData({ ppe_loading: true })
        let { flag, data, msg } = await app.post(api.PpeClassList, { id, indexno: this.state.indexno })
        let state = { ppe_loading: false }
        if (flag === 1) {
            state.ppeList = data
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 经历查询
     * @returns {Promise<void>}
     */
    experienceSource = async (page = 1) => {
        await this.setData({ experience_loading: true, e_page: page })
        const { experience_api, indexno, experience_year } = this.state
        let { flag, data, msg, total } = await app.post(experience_api, { indexno, page, year: experience_year })
        if (flag !== 1) {
            data = []
            app.alert(msg, "error")
        }
        if (page === this.state.e_page) {
            await this.setData({
                experience_loading: false,
                experienceList: utils.addArrayKey(data),
                e_total: parseInt(total || 0)
            })
        }
    }

    /**
     * 报表详情查询
     * @returns {Promise<void>}
     */
    reportSource = async (id) => {
        let params = {
            id,
            request: 'reports',
        }, { flag, data, msg } = await app.post(api.ReportsDetails, params)
        if (flag === 1) {
            let { principal, object_volunteer, object_volunteer_rear, is_domestic } = data
            if (is_domestic === '1') {
                data.domestic = '国内'
                data.area = [data.province, data.city, data.region].join(' ')
            } else if (is_domestic === '2') {
                data.domestic = '国外'
            }
            data.principal = (principal ? principal.map(p => p.vname) : []).join('、')
            let ov_vname = [], ovr_vname = []
            for (let i = 0; i < (object_volunteer || []).length; i++) {
                ov_vname.push(object_volunteer[i].vname)
            }
            for (let j = 0; j < (object_volunteer_rear || []).length; j++) {
                ovr_vname.push(object_volunteer_rear[j].vname)
            }
            data.object_volunteer = ov_vname.join('、')
            data.object_volunteer_rear = ovr_vname.join('、')
            return data
        } else {
            app.alert(msg, "error")
            return {}
        }
    }

    /**
     * 捐赠详情查询
     */
    donateSource = async (id) => {
        let { flag, data, msg } = await app.post(api.MDonateDetails, { id })
        if (flag === 1) {
            return data
        } else {
            app.alert(msg, "error")
            return {}
        }
    }

    /**
     * 排行榜查询
     */
    rankingSource = async () => {
        await this.setData({ ranking_loading: true })
        const { ranking_menu, ranking_key, ranking_filters, indexno } = this.state, params = {
            type: ranking_menu,
            indexno,
            contrast_object: '全国',
        }
        if (ranking_menu !== '1' && ranking_filters.length > 0) params.contrast_object = ranking_filters[ranking_key].teamno
        let { flag, data, msg } = await app.post(api.LUserRanking, params)
        const state = { ranking_loading: false }
        if (flag === 1) {
            state.ranking = (data.ranking || '-') + ''
            state.chartOptions = chartOptionSet(data.list, indexno)
        } else {
            app.alert(msg, "error")
        }
        if (ranking_menu === this.state.ranking_menu && ranking_key === this.state.ranking_key) {
            await this.setData(state)
        }
    }

    /**
     * 顶部导航栏点击
     */
    handleMenuClick = ({ key }) => {
        if (key) {
            let anchorElement = document.getElementById('mp-' + key)
            if (anchorElement) {
                anchorElement.scrollIntoView(true)
            }
        }
    }

    /**
     * 排行榜导航栏点击
     */
    handleRankingMenuClick = async ({ key }) => {
        if (key) {
            const { info } = this.state, state = { ranking_menu: key, ranking_filters: [], ranking_key: 0 }
            switch (key) {
                case '2':
                    state.ranking_filters = info.province
                    break
                case '3':
                    state.ranking_filters = info.teamname
                    break
            }
            await this.setData(state)
            await this.rankingSource()
        }
    }

    /**
     * 技能菜单点击
     */
    handlePPEClassClick = async ({ key }) => {
        if (key === '0') {
            await this.setData({ ppeList: this.state.info.ppe || [] })
        } else {
            await this.ppeSource(key)
        }
    }

    /**
     * 技能点击
     * @param ppe
     */
    handlePPEClick = async (ppe) => {
        //未获取技能
        if (ppe.ppe_status != 1) {
            //开放报名 使用二维码
            if (ppe.is_open == '1' && ppe.is_confirm == '1') {
                Modal.info({
                    okText: '关闭',
                    okButtonProps: ({ type: 'Default', size: 'large' }),
                    title: ppe.names,
                    icon: '',
                    centered: true,
                    width: '50vw',
                    content: (
                        <div style={{ padding: '20px 0 100px 0' }}>
                            <div style={{ margin: '20px 0' }}>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-lable-title">技能简介</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-text2">{ppe.remarks || '无'}</Col>
                                </Row>
                            </div>
                            <div>
                                <hr />
                                <Row style={{ margin: '20px 0 10px 0' }}>
                                    <Col span={24} className="ppe-lable-title">报名指引</Col>
                                </Row>
                                {ppe.open_url ?
                                    <Row type="flex" justify="center" style={{ marginBottom: 10 }}>
                                        <Col span={8}>
                                            <img width="100%" src={config.imgUrl + ppe.open_url} />
                                        </Col>
                                    </Row>
                                    : null}
                            </div>
                        </div>
                    )
                })
                //开发报名 系统的
            } else if (ppe.is_open == '1' && ppe.is_confirm == '0') {
                Modal.confirm({
                    cancelText: '关闭',
                    okText: '我要报名',
                    cancelButtonProps: ({ size: 'large' }),
                    okButtonProps: ({ size: 'large' }),
                    title: ppe.names,
                    icon: '',
                    centered: true,
                    width: '50vw',
                    content: (
                        <div style={{ padding: '20px 0 100px 0' }}>
                            <div style={{ margin: '20px 0' }}>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-lable-title">技能简介</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-text2">{ppe.remarks || '无'}</Col>
                                </Row>
                            </div>
                        </div>
                    ),
                    onOk: async () => {
                        this.props.history.push('/skillTrain')
                    }
                })
            } else {
                Modal.info({
                    okText: '关闭',
                    okButtonProps: ({ type: 'Default', size: 'large' }),
                    title: ppe.names,
                    icon: '',
                    centered: true,
                    width: '50vw',
                    content: (
                        <div style={{ padding: '20px 0 100px 0' }}>
                            <div style={{ margin: '20px 0' }}>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-lable-title">技能简介</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-text2">{ppe.remarks || '无'}</Col>
                                </Row>
                            </div>
                            {/*开放报名 外部官网*/}
                            {ppe.is_open == '2' ?
                                <div>
                                    <hr />
                                    <Row style={{ margin: '20px 0 10px 0' }}>
                                        <Col span={24} className="ppe-lable-title">报名指引</Col>
                                    </Row>
                                    {ppe.open_guide ?
                                        <Row style={{ marginBottom: 10 }}>
                                            <Col span={24} className="ppe-text2">{ppe.open_guide}</Col>
                                        </Row>
                                        : null}
                                    {ppe.open_url ?
                                        <Row style={{ marginBottom: 10 }}>
                                            <a href={ppe.open_url} target="_blank" className="ppe-text2">{ppe.open_url}</a>
                                        </Row>
                                        : null}
                                </div>
                                : null}
                        </div>
                    )
                })
            }
        } else {
            if (ppe.is_open == '1' && ppe.is_confirm == '1') {
                Modal.info({
                    okText: '关闭',
                    okButtonProps: ({ type: 'Default', size: 'large' }),
                    title: ppe.names,
                    centered: true,
                    icon: '',
                    width: '50vw',
                    content: (
                        <div style={{ padding: '20px 0 100px 0' }}>
                            <div style={{ margin: '20px 0' }}>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-lable-title">技能简介</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-text2">{ppe.remarks || '无'}</Col>
                                </Row>
                            </div>
                            <div>
                                <hr />
                                <Row style={{ margin: '20px 0 10px 0' }}>
                                    <Col span={6} className="ppe-lable-title">证书信息</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={6} className="ppe-lable">发证机构：</Col>
                                    <Col span={17} offset={1}
                                        className="ppe-text">{ppe.organization_name || '无'}</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={6} className="ppe-lable">获证时间：</Col>
                                    <Col span={17} offset={1}
                                        className="ppe-text">{ppe.datetime || '无'}</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={6} className="ppe-lable">到期时间：</Col>
                                    <Col span={17} offset={1}
                                        className="ppe-text">{ppe.is_long === '1' ? ppe.expire_time : '长期 / 无有效期'}</Col>
                                </Row>
                            </div>
                            <div>
                                <hr />
                                <Row style={{ margin: '20px 0 10px 0' }}>
                                    <Col span={24} className="ppe-lable-title">报名指引</Col>
                                </Row>
                                {ppe.open_url ?
                                    <Row type="flex" justify="center" style={{ marginBottom: 10 }}>
                                        <Col span={8}>
                                            <img width="100%" src={config.imgUrl + ppe.open_url} />
                                        </Col>
                                    </Row>
                                    : null}
                            </div>
                        </div>
                    )
                })
            } else if (ppe.is_open == '1' && ppe.is_confirm == '0') {
                Modal.confirm({
                    cancelText: '关闭',
                    okText: '我要报名',
                    cancelButtonProps: ({ size: 'large' }),
                    okButtonProps: ({ size: 'large' }),
                    title: ppe.names,
                    centered: true,
                    icon: '',
                    width: '50vw',
                    content: (
                        <div style={{ padding: '20px 0 100px 0' }}>
                            <div style={{ margin: '20px 0' }}>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-lable-title">技能简介</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-text2">{ppe.remarks || '无'}</Col>
                                </Row>
                            </div>
                            <div>
                                <hr />
                                <Row style={{ margin: '20px 0 10px 0' }}>
                                    <Col span={6} className="ppe-lable-title">证书信息</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={6} className="ppe-lable">发证机构：</Col>
                                    <Col span={17} offset={1}
                                        className="ppe-text">{ppe.organization_name || '无'}</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={6} className="ppe-lable">获证时间：</Col>
                                    <Col span={17} offset={1}
                                        className="ppe-text">{ppe.datetime || '无'}</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={6} className="ppe-lable">到期时间：</Col>
                                    <Col span={17} offset={1}
                                        className="ppe-text">{ppe.is_long === '1' ? ppe.expire_time : '长期 / 无有效期'}</Col>
                                </Row>
                            </div>
                        </div>
                    ),
                    onOk: async () => {
                        this.props.history.push('/skillTrain')
                    }
                })
            } else {
                Modal.info({
                    okText: '关闭',
                    okButtonProps: ({ type: 'Default', size: 'large' }),
                    title: ppe.names,
                    centered: true,
                    icon: '',
                    width: '50vw',
                    content: (
                        <div style={{ padding: '20px 0 100px 0' }}>
                            <div style={{ margin: '20px 0' }}>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-lable-title">技能简介</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={24} className="ppe-text2">{ppe.remarks || '无'}</Col>
                                </Row>
                            </div>
                            <div>
                                <hr />
                                <Row style={{ margin: '20px 0 10px 0' }}>
                                    <Col span={6} className="ppe-lable-title">证书信息</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={6} className="ppe-lable">发证机构：</Col>
                                    <Col span={17} offset={1}
                                        className="ppe-text">{ppe.organization_name || '无'}</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={6} className="ppe-lable">获证时间：</Col>
                                    <Col span={17} offset={1}
                                        className="ppe-text">{ppe.datetime || '无'}</Col>
                                </Row>
                                <Row style={{ marginBottom: 10 }}>
                                    <Col span={6} className="ppe-lable">到期时间：</Col>
                                    <Col span={17} offset={1}
                                        className="ppe-text">{ppe.is_long === '1' ? ppe.expire_time : '长期 / 无有效期'}</Col>
                                </Row>
                            </div>
                            {ppe.is_open == '2' ?
                                <div>
                                    <hr />
                                    <Row style={{ margin: '20px 0 10px 0' }}>
                                        <Col span={24} className="ppe-lable-title">报名指引</Col>
                                    </Row>
                                    {ppe.open_guide ?
                                        <Row style={{ marginBottom: 10 }}>
                                            <Col span={24} className="ppe-text2">{ppe.open_guide}</Col>
                                        </Row>
                                        : null}
                                    {ppe.open_url ?
                                        <Row style={{ marginBottom: 10 }}>
                                            <a href={ppe.open_url} target="_blank" className="ppe-text2">{ppe.open_url}</a>
                                        </Row>
                                        : null}
                                </div>
                                : null}
                        </div>
                    )
                })
            }
        }
    }

    /**
     * 荣誉墙点击
     * @param honor
     */
    handleHonorClick = async (honor) => {
        Modal.info({
            title: '荣誉详情',
            okText: '确定',
            centered: true,
            width: '50vw',
            content: (
                <div style={{ padding: '20px 0' }}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉图片：</Col>
                        <Col span={14} offset={1}>
                            <div style={{ height: 120 }}>
                                <img style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
                                    src={config.imgUrl + honor.img} alt="" title={honor.name} />
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉名称：</Col>
                        <Col span={14} offset={1}>{honor.name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉类型：</Col>
                        <Col span={14} offset={1}>{honor.type_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉等级：</Col>
                        <Col span={14} offset={1}>{honor.category_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>获奖时间：</Col>
                        <Col span={14} offset={1}>{honor.date}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>备注信息：</Col>
                        <Col span={14} offset={1}><span>{honor.remark || ' - '}</span></Col>
                    </Row>
                </div>
            )
        })
    }

    /**
     * 前往经历列表
     * @param type
     */
    handleToExperience = async (type) => {
        const state = { experience_visible: true, experience_key: type }
        switch (type) {
            case 'train':
                state.experience_text = '队务建设及后台经历'
                state.experience_year = this.state.train_menu_key
                state.experience_api = api.MYearTrainList
                break
            case 'rescue':
                state.experience_text = '救援经历'
                state.experience_api = api.MYearRescueList
                state.experience_year = this.state.rescue_menu_key
                break
            case 'drill':
                state.experience_text = '演练及培训经历'
                state.experience_api = api.MYearDrillList
                state.experience_year = this.state.drill_menu_key
                break
            case 'socialService':
                state.experience_text = '社会服务经历'
                state.experience_api = api.MYearSocialList
                state.experience_year = this.state.socialService_menu_key
                break
            case 'donate':
                state.experience_text = '捐赠记录'
                state.experience_api = api.MYearDonateList
                state.experience_year = this.state.donate_menu_key
                break
        }
        if (state.experience_api) {
            await this.setData(state)
            await this.experienceSource(1)
        }
    }

    /**
     * 关闭经历列表
     */
    handleCloseExperience = async () => {
        await this.setData({
            experience_visible: false,
            experience_text: '',
            experience_api: '',
            experience_year: '',
            experience_key: '',
            experienceList: [],
            e_page: 1,
            e_total: 0,
        })
    }

    /**
     * 显示详情
     * @param id
     * @param key
     */
    handleShowDetail = async (id, key) => {
        if (this.state.report_modal_loading) return
        app.alert('正在加载...', 'loading', '35%', 0)
        await this.setData({ report_modal_loading: true })
        if (key === 'donate') {
            const data = await this.donateSource(id)
            app.alertDestroy()
            Modal.info({
                title: '详细信息',
                width: '60vw',
                centered: true,
                zIndex: 9999,
                content: (
                    <div>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>捐赠类型</Col>
                            <Col span={18}>{data.donate_type === '1' ? '内部捐赠' : '外部捐赠'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>捐赠物品名称</Col>
                            <Col span={18}>{data.goods_name}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>捐赠人姓名</Col>
                            <Col span={18}>{data.donate_name}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>捐赠人联系方式</Col>
                            <Col span={18}>{data.mobile}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>捐赠对象类型</Col>
                            <Col span={18}>{data.donate_object_type === '1' ? '队伍' : '个人'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>捐赠对象</Col>
                            <Col span={18}>{data.donate_object.object_name}({data.donate_object.object_numbering})</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>捐赠数量</Col>
                            <Col span={18}>{data.number}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>审核人</Col>
                            <Col span={18}>{data.admin_name || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>审核状态</Col>
                            <Col
                                span={18}>{data.admin_audit === '0' ? '未审核' : (data.admin_audit === '1' ? '已通过' : '不通过')}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>审核时间</Col>
                            <Col span={18}>{data.admin_time || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>捐赠时间</Col>
                            <Col span={18}>{data.donate_time}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>提交时间</Col>
                            <Col span={18}>{data.add_time}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>签收人</Col>
                            <Col span={18}>{data.sign_name || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>签收状态</Col>
                            <Col span={18}>{data.is_sign === '1' ? '已签收' : '未签收'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>签收时间</Col>
                            <Col span={18}>{data.sign_time || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>捐赠原因</Col>
                            <Col span={18}>{data.donate_reason || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>物品说明</Col>
                            <Col span={18}>{data.describe || '-'}</Col>
                        </Row>
                        <Row>
                            <Col span={6}>物品图片</Col>
                            <Col span={18}>{data.images.map((img, i) => {
                                return <div style={{ height: 200, textAlign: "center" }}>
                                    <img style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
                                        src={config.imgUrl + img} key={i} alt="" />
                                </div>
                            })}</Col>
                        </Row>
                    </div>
                ),
            })
        } else {
            const data = await this.reportSource(id)
            app.alertDestroy()
            Modal.info({
                title: '详细信息',
                width: '60vw',
                centered: true,
                zIndex: 9999,
                content: (
                    <div style={{ height: '60vh', overflow: 'auto' }}>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>账号：</Col>
                            <Col span={14} offset={1}>{data.account || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>创建人：</Col>
                            <Col span={14} offset={1}>{data.vname || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>参与部门：</Col>
                            <Col span={14} offset={1}>{data.department || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>服务类型：</Col>
                            <Col span={14} offset={1}>{data.type_name || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>服务科目：</Col>
                            <Col span={14} offset={1}>{data.subject_name || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>服务项目名称：</Col>
                            <Col span={14} offset={1}>{data.title || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>相关人：</Col>
                            <Col span={14} offset={1}>{data.relevant || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>报案人：</Col>
                            <Col span={14} offset={1}>{data.reporter || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>报案人联系方式：</Col>
                            <Col span={14} offset={1}>{data.reporter_contact || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>服务对象：</Col>
                            <Col span={14} offset={1}>{data.request_object || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>服务对象联系方式：</Col>
                            <Col span={14} offset={1}>{data.request_object_contact || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>首次接触事务时间：</Col>
                            <Col span={14} offset={1}>{data.event_time || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>救援范围：</Col>
                            <Col span={14} offset={1}>{data.domestic || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>省市区：</Col>
                            <Col span={14} offset={1}>{data.area || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>具体地址：</Col>
                            <Col span={14} offset={1}>{data.address || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>任务负责人/现场指挥：</Col>
                            <Col span={14} offset={1}>{data.principal || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>出队队伍：</Col>
                            <Col span={14} offset={1}>{data.object_teamname || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>现场出队队员：</Col>
                            <Col span={14} offset={1}>{data.object_volunteer || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>后台出队队员：</Col>
                            <Col span={14} offset={1}>{data.object_volunteer_rear || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>出队人数：</Col>
                            <Col span={14} offset={1}>{data.action_people_number || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>出队时间：</Col>
                            <Col span={14} offset={1}>{data.action_time || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>是否完成：</Col>
                            <Col span={14} offset={1}>{data.whether_succeed === '11' ? '已完成' : '未完成'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>收队时间：</Col>
                            <Col span={14} offset={1}>{data.recruit_time || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>出队车辆数：</Col>
                            <Col span={14} offset={1}>{data.action_car_number || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>车牌号码：</Col>
                            <Col span={14} offset={1}>{data.number_plate || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>其他工具：</Col>
                            <Col span={14} offset={1}>{data.other_tools || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>事件进展：</Col>
                            <Col span={14} offset={1}>{data.event_progress || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>服务时长/人：</Col>
                            <Col span={14} offset={1}>{data.service_time || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>受益人数：</Col>
                            <Col span={14} offset={1}>{data.benefit_number || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>任务总结：</Col>
                            <Col span={14} offset={1}>{data.task_summary || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>总结人：</Col>
                            <Col span={14} offset={1}>{data.summary_person || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>百度网盘链接：</Col>
                            <Col span={14} offset={1}>{data.web_link || '-'}</Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                            <Col span={6}>事件图片：</Col>
                            <Col span={14} offset={1}>
                                {data.secret === '1' ? '保密任务' : (data.event_img || []).map((ei, index) => {
                                    return (
                                        <div key={index}>
                                            <img src={config.imgUrl + ei} style={{
                                                width: 'auto',
                                                height: 'auto',
                                                maxWidth: '100%'
                                            }} alt="" />
                                        </div>
                                    )
                                })}
                            </Col>
                        </Row>
                    </div>
                ),
            })
        }
        await this.setData({ report_modal_loading: false })
    }

    /**
     *  排行榜筛选变更
     */
    handleRankingFilterSelect = async ({ key }) => {
        await this.setData({ ranking_key: parseInt(key) })
        await this.rankingSource()
    }

    render() {
        let {
            menus, menu_key, info, data_loading, ppeClass_loading, ppe_loading, ppeList, ppeClassList, ranking_loading, chartOptions,
            train_menu_key, rescue_menu_key, drill_menu_key, socialService_menu_key, donate_menu_key, experience_visible, e_page, e_total,
            experience_text, experienceList, experience_loading, experience_year, experience_key, indexno, ranking_key, ranking_filters,
            ranking, ranking_menu, has_ranking, isTrue, img
        } = this.state
        let carousel_settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
        let menu_nodes = []
        if (!data_loading && !isTrue) {
            menu_nodes = menus.map(m => {
                switch (m.key) {
                    case 'information':
                        m.content = (
                            <div className="pmc-info">
                                <div className="pmci-1">
                                    <div className="pmci1-img">
                                        <img
                                            src={info.localpath ? (config.imgUrl + app.urlEncode(info.localpath)) : default_img}
                                            alt="头像" />
                                    </div>
                                    <div className="pmci1-info">
                                        <div className="pmci1-row1">
                                            <span className="yg">{info.vname}</span>
                                            <span className="yg">{info.pinyin}</span>
                                            <Popover content={
                                                <div>
                                                    <div>正式队员一周内连续签到两天可获得</div>
                                                    <div>预备队员一个月内连续签到两天可获得</div>
                                                    <div>志愿者三个月内连续签到两天可获得</div>
                                                </div>
                                            }>
                                                <span className="yg2">{info.is_active}</span>
                                            </Popover>
                                            {/* <Popover placement="rightTop"
                                             content={<QRCode value={config.sharePlayerDoman + indexno} />}
                                               title="手机扫码分享" overlayStyle={{ textAlign: 'center' }}>
                                              <Button type="primary" className="share-btn" icon="share-alt"
                                                   size="small">分享</Button>
                                           </Popover> */}
                                            {
                                                info.is_logo70 ? (
                                                    <span style={{ marginLeft: 20 }}>
                                                        <img src={config.logo70} style={{ width: '48px', height: '48px' }} alt="" />
                                                    </span>) : null
                                            }
                                        </div>
                                        <div className="pmci1-row2">
                                            {
                                                info.is_xcx === true ? (
                                                    <Tag className="xcw" color="#1890ff">已绑定小程序</Tag>) : null
                                            }
                                            <span className="rz">（{info.ppeid === '存心工作证' ? '已认证队员' : '未认证队员'}）</span>
                                            <span className="jb">
                                                <span>级别：</span>
                                                <Rate className="rate" disabled={true} defaultValue={0}
                                                    style={{ color: '#FFAB00' }} />
                                            </span>

                                            <Popover content={
                                                <div>活跃度是连续签到的天数</div>
                                            }>
                                                <span className="hyd">
                                                    <span>活跃度：</span>
                                                    <span className="hyd-val">{info.activity}</span>
                                                </span>
                                            </Popover>
                                        </div>
                                        <div className="pmci1-row3">
                                            <div className="pr-title">队伍及职务</div>
                                            <div className="pr-content" style={{ wordBreak: 'word-all', color: '#1890ff' }}>
                                                {
                                                    info.teamposition && info.teamposition.length > 0 ? info.teamposition.map((tp, i) => {
                                                        let tpns = []
                                                        switch (tp.type) {
                                                            case '3':
                                                                tpns.push(
                                                                    <Link style={{ marginRight: '.5rem' }} key={i + 1}
                                                                        to={"/ranks/team/" + tp.value}>
                                                                        <span>{tp.name}</span>
                                                                        （{tp.position && tp.position.length > 0 ? tp.position.map((p, i2) => {
                                                                            {/*<Tooltip title={p.duty || ''}><span>{p.name}</span></Tooltip>*/
                                                                            }
                                                                            let tppns = [(<span key={i2 + 1}>{p.name}</span>)]
                                                                            if (i2 < tp.position.length - 1) {
                                                                                tppns.push(<span key={i2 + 2}>、</span>)
                                                                            }
                                                                            return tppns
                                                                        }) : ' - '
                                                                        }）
                                                                    </Link>
                                                                )
                                                                break
                                                            case '2':
                                                                tpns.push(
                                                                    <Link style={{ marginRight: '.5rem' }} key={i + 1}
                                                                        to={"/ranks/province/" + tp.value}>
                                                                        <span>{tp.name}</span>
                                                                        （{tp.position && tp.position.length > 0 ? tp.position.map((p, i2) => {
                                                                            {/*<Tooltip title={p.duty || ''}><span>{p.name}</span></Tooltip>*/
                                                                            }
                                                                            let tppns = [(<span key={i2 + 1}>{p.name}</span>)]
                                                                            if (i2 < tp.position.length - 1) {
                                                                                tppns.push(<span key={i2 + 2}>、</span>)
                                                                            }
                                                                            return tppns
                                                                        }) : ' - '
                                                                        }）
                                                                    </Link>
                                                                )
                                                                break
                                                            default:
                                                                tpns.push(
                                                                    <span style={{ marginRight: '.5rem' }} key={i + 1}>
                                                                        <span>{tp.name}</span>
                                                                        （{
                                                                            tp.position && tp.position.length > 0 ? tp.position.map((p, i2) => {
                                                                                {/*<Tooltip title={p.duty || ''}><span>{p.name}</span></Tooltip>*/
                                                                                }
                                                                                let tppns = [(<span key={i2 + 1}>{p.name}</span>)]
                                                                                if (i2 < tp.position.length - 1) {
                                                                                    tppns.push(<span key={i2 + 2}>、</span>)
                                                                                }
                                                                                return tppns
                                                                            }) : ' - '
                                                                        }）
                                                                    </span>
                                                                )
                                                                break
                                                        }
                                                        if (i < info.teamposition.length - 1) {
                                                            tpns.push(<span key={i + 2}>、</span>)
                                                        }
                                                        return tpns
                                                    }) : ' - '
                                                }
                                            </div>
                                        </div>
                                        <div className="pmci1-row3">
                                            <div className="pr-title">队员身份</div>
                                            <div className="pr-content">{info.state}</div>
                                        </div>
                                        {/*<div className="pmci1-row3">*/}
                                        {/*<div className="pr-title">职务</div>*/}
                                        {/*<div className="pr-content">{info.teampositionname || '-'}</div>*/}
                                        {/*</div>*/}
                                        <div className="pmci1-row3">
                                            <div className="pr-title">存心编号</div>
                                            <div className="pr-content">{info.bsrno || '-'}</div>
                                        </div>
                                        <div className="pmci1-row3">
                                            <div className="pr-title">政治面貌</div>
                                            <div className="pr-content">
                                                {
                                                    info.politics && info.politics.length > 0 ? info.politics.map((p, i) => {
                                                        return (
                                                            <span className="politics" key={i}>
                                                                {p.icon ? (<img className="politics-img"
                                                                    src={config.imgUrl + p.icon}
                                                                    alt="" />) : null}
                                                                <span>{p.name}</span>
                                                            </span>
                                                        )
                                                    }) : '-'
                                                }
                                            </div>
                                        </div>
                                        <div className="pmci1-row3">
                                            <div className="pr-title">已购保险</div>
                                            <div className="pr-content">
                                                {info.insurance && info.insurance.length ? info.insurance.join('、') : '无'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Row className="pmci-2">
                                    <Col span={12}>身份证号：{info.idno || '-'}</Col>
                                    <Col span={12}>性别：{info.sex || '-'}</Col>
                                    <Col span={12}>手机：{info.mobile || '-'}</Col>
                                    <Col span={12}>出生年月：{info.birthdate || '-'}</Col>
                                    <Col span={12}>护照号：{info.passport || '-'}</Col>
                                    <Col span={12}>血型：{info.bloodtype || '-'}</Col>
                                    <Col span={12}>入队时间：{info.indate || '-'}</Col>
                                    <Col span={12}>最后认证时间：{info.rect || '-'}</Col>
                                    <Col span={12}>
                                        <span className="p2t">过敏史：</span>
                                        <span className="p2c">{info.drughis || '-'}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className="p2t">重大医疗史：</span>
                                        <span className="p2c">{info.medicalhis || '-'}</span>
                                    </Col>
                                </Row>
                                <Row className="pmci-2" style={{ marginTop: 10, borderTopWidth: 1, borderTopColor: '#ddd', borderTopStyle: 'solid' }}>
                                    {
                                        <div className="pmc-skill">
                                            <div className="ps-skills">
                                                <Row type="flex" align="middle">
                                                    <Col style={{ fontSize: 16 }} span={5}>无线电操作证：</Col>
                                                    <Col span={19} style={{ display: 'flex', overflow: 'auto' }}>
                                                        <div style={{ display: 'flex', overflowX: 'auto' }}>
                                                            {
                                                                info.radio.length > 0 ? info.radio.map(p => {
                                                                    return (
                                                                        <div key={p.id} title={p.names} className="pss-item"
                                                                            onClick={() => this.handlePPEClick(p)}
                                                                        >
                                                                            {p.is_open !== '0' ?
                                                                                <div className="subscript">开放报名</div>
                                                                                : null}
                                                                            <img className="img"
                                                                                src={config.imgUrl + p.icon}
                                                                                alt="图标" />
                                                                            <div className="name">{p.names}</div>
                                                                            {
                                                                                p.ppe_status !== '1' ? (
                                                                                    <div className="lock">
                                                                                        <i className="iconfont icon-suo" />
                                                                                    </div>
                                                                                ) : null
                                                                            }
                                                                        </div>
                                                                    )
                                                                }) : ''
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="ps-skills">
                                                <Row type="flex" align="middle">
                                                    <Col style={{ fontSize: 16 }} span={5}>急救证：</Col>
                                                    <Col span={19} style={{ display: 'flex', overflow: 'auto' }}>
                                                        <div style={{ display: 'flex', overflowX: 'auto' }}>
                                                            {
                                                                info.treatment.length > 0 ? info.treatment.map(p => {
                                                                    return (
                                                                        <div key={p.id} title={p.names} className="pss-item"
                                                                            onClick={() => this.handlePPEClick(p)}
                                                                        >
                                                                            {p.is_open !== '0' ?
                                                                                <div className="subscript">开放报名</div>
                                                                                : null}
                                                                            <img className="img"
                                                                                src={config.imgUrl + p.icon}
                                                                                alt="图标" />
                                                                            <div className="name">{p.names}</div>
                                                                            {
                                                                                p.ppe_status !== '1' ? (
                                                                                    <div className="lock">
                                                                                        <i className="iconfont icon-suo" />
                                                                                    </div>
                                                                                ) : null
                                                                            }
                                                                        </div>
                                                                    )
                                                                }) : ''
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="ps-skills">
                                                <Row type="flex" align="middle">
                                                    <Col style={{ fontSize: 16 }} span={5}>国家应急救援员证：</Col>
                                                    <Col span={19} style={{ display: 'flex', overflow: 'auto' }}>
                                                        <div style={{ display: 'flex', overflowX: 'auto' }}>
                                                            {
                                                                info.emergency_rescue.length > 0 ? info.emergency_rescue.map(p => {
                                                                    return (
                                                                        <div key={p.id} title={p.names} className="pss-item"
                                                                            onClick={() => this.handlePPEClick(p)}
                                                                        >
                                                                            {p.is_open !== '0' ?
                                                                                <div className="subscript">开放报名</div>
                                                                                : null}
                                                                            <img className="img"
                                                                                src={config.imgUrl + p.icon}
                                                                                alt="图标" />
                                                                            <div className="name">{p.names}</div>
                                                                            {
                                                                                p.ppe_status !== '1' ? (
                                                                                    <div className="lock">
                                                                                        <i className="iconfont icon-suo" />
                                                                                    </div>
                                                                                ) : null
                                                                            }
                                                                        </div>
                                                                    )
                                                                }) : ''
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    }
                                </Row>
                                {
                                    info.volunteer_state === '4' ? <div className='pmci-state-img leave-img' /> :
                                        (info.volunteer_state === '5' ?
                                            <div className='pmci-state-img kaichu-img' /> : null)
                                }
                            </div>
                        )
                        break
                    case 'skill':
                        m.content = (
                            <div className="pmc-skill pmc-wmp">
                                {
                                    ppeClass_loading ? loadNode() : (
                                        <div>
                                            <Menu mode="horizontal" className="ps-menu" defaultSelectedKeys={['0']}
                                                onClick={this.handlePPEClassClick}>
                                                <MenuItem key="0">已获得</MenuItem>
                                                {
                                                    ppeClassList.map(p => {
                                                        return (
                                                            <MenuItem key={p.id}>{p.names}</MenuItem>
                                                        )
                                                    })
                                                }
                                            </Menu>
                                            <div className="ps-skills">
                                                {
                                                    ppe_loading ? loadNode() :
                                                        ppeList.length > 0 ? ppeList.map(p => {
                                                            return (
                                                                <div key={p.id} title={p.names} className="pss-item"
                                                                    onClick={() => this.handlePPEClick(p)}
                                                                >
                                                                    {p.is_open !== '0' ?
                                                                        <div className="subscript">开放报名</div>
                                                                        : null}
                                                                    <img className="img"
                                                                        src={config.imgUrl + p.icon}
                                                                        alt="图标" />
                                                                    <div className="name">{p.names}</div>
                                                                    {
                                                                        p.ppe_status !== '1' ? (
                                                                            <div className="lock">
                                                                                <i className="iconfont icon-suo" />
                                                                            </div>
                                                                        ) : null
                                                                    }
                                                                </div>
                                                            )
                                                        }) : notNode('暂无对应技能')
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        )
                        break
                    case 'equipment':
                        m.content = (
                            <div className="pmc-equipment pmc-wmp">
                                <Slider {...carousel_settings}>
                                    {
                                        info.mall && info.mall.length > 0 ? info.mall.map((m, i) => {
                                            return (
                                                <div key={i + ''} className="pe-item" title={m.ppename}>
                                                    <div className="pei-img">
                                                        <img
                                                            src={config.imgUrl + m.localpath}
                                                            alt="装备图片" />
                                                    </div>
                                                    <div className="pei-name">
                                                        {m.ppename}
                                                    </div>
                                                </div>
                                            )
                                        }) : notNode('暂未购买装备')
                                    }
                                </Slider>
                            </div>
                        )
                        break
                    case 'honorwall':
                        m.content = (
                            <div className="pmc-equipment pmc-honor">
                                <Slider {...carousel_settings}>
                                    {
                                        info.honor && info.honor.length > 0 ? info.honor.map((m, i) => {
                                            return (
                                                <div key={i} className="pe-item" title={m.name} onClick={() => this.handleHonorClick(m)}>
                                                    <div className="pei-img" style={{ cursor: 'pointer' }}>
                                                        <img src={config.imgUrl + m.img} alt="荣誉图片" />
                                                    </div>
                                                    <div className="pei-name">
                                                        {m.name}
                                                    </div>
                                                </div>
                                            )
                                        }) : notNode('暂无荣誉信息')
                                    }
                                </Slider>
                                {
                                    info.honor && info.honor.length >= 15 ? (
                                        <div className="more-link">
                                            <Link className="link" to={'/player/honorwall/' + indexno}>
                                                <span className="more-link-text">更多</span>
                                                <Icon type="double-right" />
                                            </Link>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                        break
                    case 'ranking':
                        if (!has_ranking) {
                            m.content = notNode('该队员已离队，不纳入排行榜')
                            break
                        }
                        let rnfs = 14
                        if (ranking.length > 4) {
                            rnfs = 36
                        } else if (ranking.length > 3) {
                            rnfs = 42
                        } else if (ranking.length > 2) {
                            rnfs = 60
                        } else {
                            rnfs = 68
                        }
                        m.content = (
                            <div className="pmc-ranking">
                                <Menu mode="horizontal" className="pr-menu" defaultSelectedKeys={["3"]}
                                    onClick={this.handleRankingMenuClick}>
                                    <MenuItem key="3">队内排行</MenuItem>
                                    <MenuItem key="2">省内排行</MenuItem>
                                    <MenuItem key="1">国内排行</MenuItem>
                                </Menu>
                                <div className="pr-content">
                                    {
                                        ranking_menu !== '1' ? (
                                            <div className="prc-filter">
                                                <Dropdown trigger={['click']} overlay={
                                                    <Menu onClick={this.handleRankingFilterSelect}>
                                                        {ranking_filters.map((t, i) => {
                                                            return (<MenuItem key={i + ''}>{t.teamname}</MenuItem>)
                                                        })}
                                                    </Menu>
                                                }>
                                                    <span>
                                                        {ranking_filters[ranking_key].teamname} <Icon type="down" />
                                                    </span>
                                                </Dropdown>
                                            </div>
                                        ) : null
                                    }
                                    {
                                        ranking_loading ? loadNode() : (
                                            <Row className="prc-info" type="flex" align="middle">
                                                <div className="no">
                                                    <div className="n-no">
                                                        <span style={{ fontSize: rnfs }}>{ranking}</span>
                                                    </div>
                                                    <div>
                                                        {
                                                            ranking_menu === '1' ? '国内排名' : (ranking_menu === '2' ? '省内排名' : '队内排名')
                                                        }
                                                    </div>
                                                </div>
                                                <div className="chart">
                                                    <BarReact option={chartOptions} height={280} />
                                                </div>
                                            </Row>
                                        )
                                    }
                                </div>
                            </div>
                        )
                        break
                    case 'train':
                        m.content = (
                            <div className="pmc-train pmc-wmp">
                                <Menu mode="horizontal" className="pt-menu" defaultSelectedKeys={[train_menu_key]}
                                    onClick={({ key }) => {
                                        this.setData({ train_menu_key: key })
                                    }}>
                                    {
                                        info.trainYear.map(ty => {
                                            return (
                                                <MenuItem key={ty} className="ptm-menu">
                                                    <div className="ptm-ci">
                                                        <span className="val">{info.train[ty].total}</span>
                                                        <span>次</span>
                                                    </div>
                                                    <div className="ptm-name">{ty}年</div>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                                <div className="pt-items">
                                    {
                                        info.train[train_menu_key].data.length > 0 ?
                                            info.train[train_menu_key].data.map(d => {
                                                return (
                                                    <Row key={d.id} onClick={() => this.handleShowDetail(d.id, 'train')}
                                                        className="pti-item">
                                                        <Col span={12} className="ptii-name">{d.title}</Col>
                                                        <Col span={12}
                                                            className="ptii-date">{d.action_time} ~ {d.recruit_time}</Col>
                                                    </Row>
                                                )
                                            }) : notNode('暂无队务建设及后台经历')
                                    }
                                    {
                                        info.train[train_menu_key].data.length >= 4 ? (
                                            <div className="more-link" onClick={() => this.handleToExperience('train')}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </div>
                                        ) : null
                                    }
                                </div>

                            </div>
                        )
                        break
                    case 'rescue':
                        m.content = (
                            <div className="pmc-train pmc-wmp">
                                <Menu mode="horizontal" className="pt-menu" defaultSelectedKeys={[rescue_menu_key]}
                                    onClick={({ key }) => {
                                        this.setData({ rescue_menu_key: key })
                                    }}>
                                    {
                                        info.rescueYear.map(ty => {
                                            return (
                                                <MenuItem key={ty} className="ptm-menu">
                                                    <div className="ptm-ci">
                                                        <span className="val">{info.rescue[ty].total}</span>
                                                        <span>次</span>
                                                    </div>
                                                    <div className="ptm-name">{ty}年</div>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                                <div className="pt-items">
                                    {
                                        info.rescue[rescue_menu_key].data.length > 0 ?
                                            info.rescue[rescue_menu_key].data.map(d => {
                                                return (
                                                    <Row key={d.id}
                                                        onClick={() => this.handleShowDetail(d.id, 'rescue')}
                                                        className="pti-item">
                                                        <Col span={12} className="ptii-name">{d.title}</Col>
                                                        <Col span={12}
                                                            className="ptii-date">{d.action_time} ~ {d.recruit_time}</Col>
                                                    </Row>
                                                )
                                            }) : notNode('暂无救援经历')
                                    }
                                    {
                                        info.rescue[rescue_menu_key].data.length >= 4 ? (
                                            <div className="more-link"
                                                onClick={() => this.handleToExperience('rescue')}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        )
                        break
                    case 'drill':
                        m.content = (
                            <div className="pmc-train pmc-wmp">
                                <Menu mode="horizontal" className="pt-menu" defaultSelectedKeys={[drill_menu_key]}
                                    onClick={({ key }) => {
                                        this.setData({ drill_menu_key: key })
                                    }}>
                                    {
                                        info.drillYear.map(ty => {
                                            return (
                                                <MenuItem key={ty} className="ptm-menu">
                                                    <div className="ptm-ci">
                                                        <span className="val">{info.drill[ty].total}</span>
                                                        <span>次</span>
                                                    </div>
                                                    <div className="ptm-name">{ty}年</div>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                                <div className="pt-items">
                                    {
                                        info.drill[drill_menu_key].data.length > 0 ?
                                            info.drill[drill_menu_key].data.map(d => {
                                                return (
                                                    <Row key={d.id} onClick={() => this.handleShowDetail(d.id, 'drill')}
                                                        className="pti-item">
                                                        <Col span={12} className="ptii-name">{d.title}</Col>
                                                        <Col span={12}
                                                            className="ptii-date">{d.action_time} ~ {d.recruit_time}</Col>
                                                    </Row>
                                                )
                                            }) : notNode('暂无演练及培训经历')
                                    }
                                    {
                                        info.drill[drill_menu_key].data.length >= 4 ? (
                                            <div className="more-link" onClick={() => this.handleToExperience('drill')}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        )
                        break
                    case 'social':
                        m.content = (
                            <div className="pmc-train pmc-wmp">
                                <Menu mode="horizontal" className="pt-menu"
                                    defaultSelectedKeys={[socialService_menu_key]}
                                    onClick={({ key }) => {
                                        this.setData({ socialService_menu_key: key })
                                    }}>
                                    {
                                        info.socialServiceYear.map(ty => {
                                            return (
                                                <MenuItem key={ty} className="ptm-menu">
                                                    <div className="ptm-ci">
                                                        <span className="val">{info.socialService[ty].total}</span>
                                                        <span>次</span>
                                                    </div>
                                                    <div className="ptm-name">{ty}年</div>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                                <div className="pt-items">
                                    {
                                        info.socialService[socialService_menu_key].data.length > 0 ?
                                            info.socialService[socialService_menu_key].data.map(d => {
                                                return (
                                                    <Row key={d.id}
                                                        onClick={() => this.handleShowDetail(d.id, 'socialService')}
                                                        className="pti-item">
                                                        <Col span={12} className="ptii-name">{d.title}</Col>
                                                        <Col span={12}
                                                            className="ptii-date">{d.action_time} ~ {d.recruit_time}</Col>
                                                    </Row>
                                                )
                                            }) : notNode('暂无社会服务经历')
                                    }
                                    {
                                        info.socialService[socialService_menu_key].data.length >= 4 ? (
                                            <div className="more-link"
                                                onClick={() => this.handleToExperience('socialService')}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        )
                        break
                    case 'donation':
                        m.content = (
                            <div className="pmc-train pmc-wmp">
                                <Menu mode="horizontal" className="pt-menu" defaultSelectedKeys={[donate_menu_key]}
                                    onClick={({ key }) => {
                                        this.setData({ donate_menu_key: key })
                                    }}>
                                    {
                                        info.donateYear.map(ty => {
                                            return (
                                                <MenuItem key={ty} className="ptm-menu">
                                                    <div className="ptm-ci">
                                                        <span className="val">{info.donate[ty].total}</span>
                                                        <span>次</span>
                                                    </div>
                                                    <div className="ptm-name">{ty}年</div>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                                <div className="pt-items">
                                    {
                                        info.donate[donate_menu_key].data.length > 0 ?
                                            info.donate[donate_menu_key].data.map(d => {
                                                return (
                                                    <Row key={d.id}
                                                        onClick={() => this.handleShowDetail(d.id, 'donate')}
                                                        className="pti-item">
                                                        <Col span={12} className="ptii-name">{d.title}</Col>
                                                        <Col span={12}
                                                            className="ptii-date">{d.action_time}</Col>
                                                    </Row>
                                                )
                                            }) : notNode('暂无捐赠记录')
                                    }
                                    {
                                        info.donate[donate_menu_key].data.length >= 4 ? (
                                            <div className="more-link"
                                                onClick={() => this.handleToExperience('donate')}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        )
                        break
                    case 'leaveteam':
                        m.content = (
                            <div className="pmc-leaveteam pmc-wmp">
                                {
                                    (info.leaveInfo || []).map((l, i) => {
                                        return (
                                            <div className="pl-item" key={i + ''}>
                                                <div className="pli-date">{l.outdate} {l.leave_teamname} （离队）
                                                </div>
                                                <div className="pli-reason">
                                                    <div className="t">原因：</div>
                                                    <div className="c">{l.leave_reason}</div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                {
                                    info.volunteer_state === '5' ? (
                                        <div className="pl-item">
                                            <div className="pli-date">{info.outdate || '-'} （清退）</div>
                                            <div className="pli-reason">
                                                <div className="t">原因：</div>
                                                <div className="c">{info.leave_reason || '-'}</div>
                                            </div>
                                        </div>
                                    ) : null
                                }
                                {info.leaveInfo && info.leaveInfo.length > 0 || info.volunteer_state === '5' ? null : notNode('暂无离队/清退记录')}
                            </div>
                        )
                        break
                }
                return m
            })
        }
        return (
            <div className="member-page">
                <Menu mode="horizontal" className="mp-menu" defaultSelectedKeys={menu_key}
                    onClick={this.handleMenuClick}>
                    {
                        !isTrue ? menus.map(m => {
                            return (
                                <MenuItem key={m.key}>{m.name}</MenuItem>
                            )
                        })
                            :
                            null
                    }
                </Menu>

                <div className="mc-scroll">
                    <div className="mp-content">
                        <div style={{ textAlign: 'right', paddingTop: 10 }}>
                            <Button icon="rollback" onClick={() => app.backPage(this)}>返回</Button>
                        </div>
                        {
                            isTrue ? <img style={{ display: "block", margin: "0 auto", marginTop: "100px" }} src={img} alt="" /> : ''
                        }
                        {
                            data_loading ? loadNode() : menu_nodes.map((m, i) => {
                                return (
                                    <div key={i} className="mpc-item" id={'mp-' + m.key}>
                                        <div className="mpci-title">{m.name}</div>
                                        <div className="mpci-content">
                                            {m.content}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <Modal
                    visible={experience_visible}
                    footer={null}
                    title={info.vname + experience_year + '年' + experience_text}
                    maskClosable={false}
                    centered={true}
                    width='80vw'
                    bodyStyle={{ height: 'calc(80vh - 55px)', overflow: 'auto' }}
                    zIndex={1010}
                    onCancel={this.handleCloseExperience}
                    className="member-experience-modal-class"
                >
                    <div className="e-items">
                        {
                            experience_loading ? loadNode() : experienceList.map((e, i) => {
                                return (
                                    <Row key={i} className="ei-item"
                                        onClick={() => this.handleShowDetail(e.id, experience_key)}>
                                        <Col span={14} className="name">{e.title}</Col>
                                        <Col span={10}
                                            className="date">{e.action_time + (e.recruit_time ? ` ~ ${e.recruit_time}` : '')}</Col>
                                    </Row>
                                )
                            })
                        }
                    </div>
                    <div className="e-page">
                        <Pagination current={e_page} size="small" pageSize={20} total={e_total} hideOnSinglePage={true}
                            onChange={this.experienceSource} />
                    </div>
                </Modal>
            </div>
        )
    }
}

export default PMember



// WEBPACK FOOTER //
// ./src/routes/playerInfo/PMember.jsx